export const useIsDesktop = () => {
  const isDesktop = window.innerWidth >= 450;
  return isDesktop;
};